import React from "react";
import styled from "styled-components";
import { color, font } from "../tokens";
import { MonoLabel, Reveal, SectionRow, RowMeta, TwoTone } from "../primitives";
import { EraSection } from "../data";
import AnimatedIcon from "../icons";

const Number = styled.span`
  font-family: ${font.display};
  font-size: clamp(30px, 3.2vw, 48px);
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.01em;
`;

const LabelStack = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const EraName = styled.h2`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${font.mono};
  font-size: 12.5px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: ${color.ink};
`;

const Rule = styled.div`
  height: 1px;
  background: ${color.line};
  margin-bottom: clamp(24px, 4vh, 44px);
`;

/**
 * Numbered era row: `01 <icon> ZIP CO` left, statement centre, years
 * right. The numbers are the career sequence mirrored by the timeline
 * rail on the left edge.
 */
const EraHeader: React.FC<{
  era: EraSection;
  statementInk: string;
  statementMuted?: string;
}> = ({ era, statementInk, statementMuted }) => (
  <Reveal>
    <Rule />
    <SectionRow>
      <LabelStack>
        <Number aria-hidden>{era.number}</Number>
        <EraName>
          <AnimatedIcon name={era.icon} size={14} strokeWidth={2} />
          {era.title}
        </EraName>
      </LabelStack>
      <TwoTone ink={statementInk} muted={statementMuted} />
      <RowMeta>
        <MonoLabel>{era.years}</MonoLabel>
      </RowMeta>
    </SectionRow>
  </Reveal>
);

export default EraHeader;
